import { batchListMasterDataAsOptions, getMasterDataRecord, listMasterdataContent, listMasterdataRecords } from "@/actions/masterdata-action";
import { AppConfig } from "@/config/app";
import { post } from "@/utils/api-util";

/**
 * 列出所有主数据
 * @returns
 */
export const listEmailTemplates = async () => {
    return listMasterdataRecords('EmailNotifyTemplate', AppConfig.masterdata.defaultVersion);
}
/**
 * 获取时间范围选项
 * @returns
 */
export const getTimeRangeOptions = async () => {
    return batchListMasterDataAsOptions([{ masterdataCode: 'TimeRangeOptions', version: AppConfig.masterdata.defaultVersion }]);
}

/**
 * 获取权限类型
 * @returns 
 */
export const getPermissionTypes = async () => {
    return listMasterdataContent('PermissionTypes', true);
}

/**
 * 获取菜单选项
 * @returns
 */
export const getMenuItems = async () => {
    return listMasterdataContent('MenuItem', true);
}

/**
 * 获取系统配置项（初始化时使用，禁用 API 提示）
 * @returns 
 */
export const getAppConfig = async () => {
    return getMasterDataRecord('AppInfo', AppConfig.masterdata.defaultVersion, 'AppInfo', { useApiTip: false });
}

/**
 * 获取导入配置
 * @returns 
 */
export const getImportConfig = async (code: string) => {
    return getMasterDataRecord('ImportConfig', AppConfig.masterdata.defaultVersion, code);
}

/**
 * 获取表格分页配置
 * @returns 
 */
export const getTablePaginationConfig = async () => {
    return getMasterDataRecord('TablePagination', AppConfig.masterdata.defaultVersion, 'default');
}

/**
 * 批量导入
 * @param thingCode 实体编码
 * @param thingName 实体名称
 * @param batchCode 批次编码
 * @param records 导入数据
 * @returns 
 */
export const importBatchThings = async (thingCode: string, thingName: string, batchCode: string, records: any[]) => {
    return (await post(`/api/v1/things/import`, { thingCode, thingName, batchCode, records }, {
        loadingMessage: `正在批量导入${thingName}`,
        successMessage: `${thingName}批量导入成功`
    })).data;
}